import React, { SFC } from 'react'
import Organization from '../../../types/Organization'
import Provider from '../../../types/Provider'
import { Col, Row } from 'react-bootstrap'
import './index.css'

interface Props {
  organizationView: boolean;
  provider: Provider;
  organization: Organization;
}

const generateData = (organizationView: boolean, provider: Provider, organization: Organization) => (
  organizationView ? (
    <Col xs={12} sm={12} md={12} lg={12}>
      <Row className="contact-row">
        <Col className="contact-left-col-row" xs={4} sm={4} md={4} lg={4}>
          <div className="contact-left-col">
							Provider Name
          </div>
        </Col>
        <Col xs={8} sm={8} md={8} lg={8} className='contact-row-right'>
          <div className="contact-right-col">
            {
              organization.organization_name
            }
          </div>
        </Col>
      </Row>
      <Row className="contact-row">
        <Col className="contact-left-col-row" xs={4}>
          <div className="contact-left-col">
							Type
          </div>
        </Col>
        <Col xs={8} className='contact-row-right'>
          <div className="contact-right-col">
							Organization
          </div>
        </Col>
      </Row>
      <Row className="contact-row">
        <Col className="contact-left-col-row" xs={4}>
          <div className="contact-left-col">
							Tax ID
          </div>
        </Col>
        <Col xs={8} className='contact-row-right'>
          <div className="contact-right-col">
            {
              organization.organization_tax_id_number
            }
          </div>
        </Col>
      </Row>
      <Row className="contact-row">
        <Col className="contact-left-col-row" xs={4} sm={4} md={4} lg={4}>
          <div className="contact-left-col">
							Address Line 1
          </div>
        </Col>
        <Col xs={8} sm={8} md={8} lg={8} className='contact-row-right'>
          <div className="contact-right-col">
            {
              organization.organization_address_1
            }
          </div>
        </Col>
      </Row>
      <Row className="contact-row">
        <Col className="contact-left-col-row" xs={4}>
          <div className="contact-left-col">
							Address Line 2
          </div>
        </Col>
        <Col xs={8} className='contact-row-right'>
          <div className="contact-right-col">
            {
              organization.organization_address_2
            }
          </div>
        </Col>
      </Row>
      <Row className="contact-row">
        <Col className="contact-left-col-row" xs={4}>
          <div className="contact-left-col">
							City
          </div>
        </Col>
        <Col xs={8} className='contact-row-right'>
          <div className="contact-right-col">
            {
              organization.organization_city
            }
          </div>
        </Col>
      </Row>
      <Row className="contact-row">
        <Col className="contact-left-col-row" xs={4}>
          <div className="contact-left-col">
							State
          </div>
        </Col>
        <Col xs={8} className='contact-row-right'>
          <div className="contact-right-col">
            {
              organization.organization_state
            }
          </div>
        </Col>
      </Row>
      <Row className="contact-row">
        <Col className="contact-left-col-row" xs={4}>
          <div className="contact-left-col">
							Zip
          </div>
        </Col>
        <Col xs={8} className='contact-row-right'>
          <div className="contact-right-col">
            {
              organization.organization_zip_code
            }
          </div>
        </Col>
      </Row>
    </Col>
  ) : (
    <Col xs={12} sm={12} md={12} lg={12}>
      <Row className="contact-row">
        <Col className="contact-left-col-row" xs={4} sm={4} md={4} lg={4}>
          <div className="contact-left-col">
							Provider Name
          </div>
        </Col>
        <Col xs={8} sm={8} md={8} lg={8} className='contact-row-right'>
          <div className="contact-right-col">
            {
              provider.provider_name
            }
          </div>
        </Col>
      </Row>
      <Row className="contact-row">
        <Col className="contact-left-col-row" xs={4}>
          <div className="contact-left-col">
							Type
          </div>
        </Col>
        <Col xs={8} className='contact-row-right'>
          <div className="contact-right-col">
							Facility
          </div>
        </Col>
      </Row>
      <Row className="contact-row">
        <Col className="contact-left-col-row" xs={4}>
          <div className="contact-left-col">
							Tax ID
          </div>
        </Col>
        <Col xs={8} className='contact-row-right'>
          <div className="contact-right-col">
            {
              provider.tax_id_number
            }
          </div>
        </Col>
      </Row>
      <Row className="contact-row">
        <Col className="contact-left-col-row" xs={4} sm={4} md={4} lg={4}>
          <div className="contact-left-col">
							Address Line 1
          </div>
        </Col>
        <Col xs={8} sm={8} md={8} lg={8} className='contact-row-right'>
          <div className="contact-right-col">
            {
              provider.address_1
            }
          </div>
        </Col>
      </Row>
      <Row className="contact-row">
        <Col className="contact-left-col-row" xs={4}>
          <div className="contact-left-col">
							Address Line 2
          </div>
        </Col>
        <Col xs={8} className='contact-row-right'>
          <div className="contact-right-col">
            {
              provider.address_2
            }
          </div>
        </Col>
      </Row>
      <Row className="contact-row">
        <Col className="contact-left-col-row" xs={4}>
          <div className="contact-left-col">
							City
          </div>
        </Col>
        <Col xs={8} className='contact-row-right'>
          <div className="contact-right-col">
            {
              provider.city
            }
          </div>
        </Col>
      </Row>
      <Row className="contact-row">
        <Col className="contact-left-col-row" xs={4}>
          <div className="contact-left-col">
							State
          </div>
        </Col>
        <Col xs={8} className='contact-row-right'>
          <div className="contact-right-col">
            {
              provider.state
            }
          </div>
        </Col>
      </Row>
      <Row className="contact-row">
        <Col className="contact-left-col-row" xs={4}>
          <div className="contact-left-col">
							Zip
          </div>
        </Col>
        <Col xs={8} className='contact-row-right'>
          <div className="contact-right-col">
            {
              provider.zip_code
            }
          </div>
        </Col>
      </Row>
    </Col>	
  )
)

const GeneralInfo: SFC<Props> = (props: Props) => {
  const { organization, organizationView, provider} = props

  return (  
    <div className='general-info-container'>
      {generateData(organizationView,provider,organization)}
    </div>
  )
}
export default GeneralInfo
